<template>
  <b-container fluid class="printPage px-0">
    <b-card>
      <div class="overflow full-height" v-if="viewingOrder">

        <div v-for="(item, index) in items" :key="index" class="border-bottom p-2">
          <div class="d-flex flex-row full-width">
            <span class="item-quanity text-primary font-weight-bold">{{item.quantity}}</span>
            <span class="px-1"></span>
            <span class="item-list-title flex-grow-1 text-justify font-weight-bold">{{item.title}} </span>
            <span class="item-list-title text-justify font-weight-bold"> {{(itemTotal(item)/100.0) | currency}} </span>
          </div>
          <div v-if="item.specialNote" class="d-flex flex-row full-width font-italic font-weight-bold">
            <span class="px-2"></span>
            ***{{item.specialNote}}
          </div>
          <div class="item-options">
              <div v-for="(option, index) in item.options" :key="`option-${index}`">
                <span class="px-2"></span>
                <span class="text-primary text-center" v-if="option.count > 1">{{option.count}}x</span> 
                <span class="text-justify">{{option.title}}</span>
              </div>                        
          </div>
        </div>
        
        <p class="py-1" />
        <div class="d-flex flex-row full-width" v-if="subTotal > 0">
          <span class="px-1"></span>
          <span class="item-list-title flex-grow-1 text-justify">SubTotal</span>
          <span class="item-list-title text-justify"> {{(subTotal/100.0) | currency}} </span>
        </div>
        <div class="d-flex flex-row full-width" v-if="tax > 0">
          <span class="px-1"></span>
          <span class="item-list-title flex-grow-1 text-justify">Tax1</span>
          <span class="item-list-title text-justify"> {{(tax/100.0) | currency}} </span>
        </div>
        <div class="d-flex flex-row full-width" v-if="tax2 > 0">
          <span class="px-1"></span>
          <span class="item-list-title flex-grow-1 text-justify">Tax2</span>
          <span class="item-list-title text-justify"> {{(tax2/100.0) | currency}} </span>
        </div>
        <div class="d-flex flex-row full-width" v-if="tip > 0">
          <span class="px-1"></span>
          <span class="item-list-title flex-grow-1 text-justify">Tip</span>
          <span class="item-list-title text-justify"> {{(tip/100.0) | currency}} </span>
        </div>
        <div class="d-flex flex-row full-width" v-if="total > 0">
          <span class="px-1"></span>
          <span class="item-list-title flex-grow-1 text-justify">Total</span>
          <span class="item-list-title text-justify"> {{(total/100.0) | currency}} </span>
        </div>

      </div>
    </b-card>
  </b-container>
</template>

<script>

import { mapState } from 'vuex'

export default {
    components : {
    },
    data(){ return { viewingOrder : [] } },
    props : {
       orderResult : { type : Object }
    },
    watch:{
      orderResult () {
        this.get_order_status()           
      },
    },
    computed : { 
		  ...mapState({ }),
      _id() {
        return this.viewingOrder ? this.viewingOrder._id : 0
      },
      orderTime() {
          return this.viewingOrder ? this.viewingOrder.orderTime : 0
      },
      startTime() {
          return this.viewingOrder ? this.viewingOrder.startTime : 0
      },
      timeEstimate() {
          return this.viewingOrder ? this.viewingOrder.timeEstimate : 0
      },
      completeTime() {
          return this.viewingOrder ? this.viewingOrder.completeTime : 0
      },
    
      subTotal() {
        return this.viewingOrder ? this.viewingOrder.subTotal : 0;
      },
      tax() {
        return this.viewingOrder ? this.viewingOrder.tax : 0;
      },
      tax2() {
        return this.viewingOrder ? this.viewingOrder.tax2 : 0;
      },
      tip() {
        return this.viewingOrder ? this.viewingOrder.tip : 0;
      },
      total() {
        return this.viewingOrder ? this.viewingOrder.total : 0;
      },
      refund() {
        return this.viewingOrder ? this.viewingOrder.refund : 0;
      },

      name() {
        return this.viewingOrder ? this.viewingOrder.name : ""
      },
      phone() {
        return this.viewingOrder ? this.viewingOrder.phone : ""
      },
      orderNumber() {
        return this.viewingOrder ? this.viewingOrder.orderNumber : ""
      },
      items() {
        return this.viewingOrder ? this.viewingOrder.items : []
      },
    },
    mounted() {
    },
    created() {
      this.get_order_status()
    },
    destroyed(){

    },
    methods: {
        printOrder(){
          window.print()
        },
        itemTotal({price, quantity, options}) {
            let optionsTotal = 0
            options.forEach(option => {
              optionsTotal += option.price
            })
          return ( optionsTotal + price ) *quantity
        },
        get_order_status() {
            if(!this.orderResult || this.orderResult._id === undefined){
                return
            }
            this.$store
            .dispatch('orderStatus', this.orderResult)
            .then(r => {
                  this.viewingOrder = r
            }).catch(e => {
                console.log(e);
                this.viewingOrder  = null;
            })
        },
    },    
    beforeDestroy () {
    }
}
</script>
<style scoped>
    img.icon {
        width: 65px;
        height: 65px;
        padding: 5px;
        margin: auto;
    }
    div.full-width {
        width: 100%;
    }
    .break {
      flex-basis: 100%;
      height: 0;
    }
    .overflow {
        overflow: auto;
    }
    .full-height {
        height: 100%;
    }

    @media print {
      .printPage{
        height: unset !important;
      }
    }
</style>